export interface AddonProps {
    aid: string; // 插件id
    type: string; // 插件类型，例如: 'latex'
    extraData: string; // 插件包含的数据
    docElement?: any;
}

export class Addon {
    public constructor(
        public docsImageObject: any,
        public type: string,
    ) { }

    public getAddonProps = () => {
        const props: AddonProps = {
            aid: this.docsImageObject.addonId,
            type: this.type,
            extraData: this.docsImageObject.extraData || '',
            docElement: this.docsImageObject,
        };

        return props;
    };
}
